// app_connection.js 내의 onMessageListner 에서 호출되는 api callback method Mixin
// 20.03.10   sang
import Const from '../helpers/Const';
export const AppConnectionMixin = {
  computed: {
    storeChk(){
      return ( 
        typeof this.$store != 'undefined'  
        && typeof this.$store.state != 'undefined'  
        && typeof this.$store.state.host.prime != 'undefined'
      );
    },
    S3UploadURL() {
      var url = '/api/v1App/atts';
      return (this.storeChk) ? (this.$store.state.host.prime + url) : url ;
    },
    webImagePath() {
      var path = '/admin/img/bmw-logo.51be632b.png';
      return (this.storeChk) ? (this.$store.state.host.prime + path) : path ;
    },
  },
  data() {
    return {
      //S3UploadURL: `https://prime.bmw-plus.co.kr/api/v1App/atts`,
      //webImagePath: `https://prime.bmw-plus.co.kr/admin/img/bmw-logo.51be632b.png`,
      // S3UploadURL: `${this.$store.state.host.prime}/api/v1App/atts`,
      // webImagePath: `${this.$store.state.host.prime}/admin/img/bmw-logo.51be632b.png`,
    }
  },

  methods: {
    // callbackOCRCarReg(value) {
    callbackOCRCarRegSet(value) {
      /**
       * {
       *    "user_id":"epikar@epikar.com",
       *    "type":"3",
       *    "handleKey":"handleKey",
       *    "url":"https://s3.ap-northeast-2.amazonaws.com/bmw.prime.stage/file/att/50/temp/202205/63RIxMNMADbqr0Ma_num_reg.jpg",
       *    "need_modify_data":false,
       *    "data":"{
       *        "car_vin":"차대번호",
       *        "car_reg_no":"12가1234",
       *        "reg_date":"2016 01 01",
       *        "model":"5X51 2016",
       *        "owner_name":"홍길동 "
       *    }"
       */
      let result = value.replace('"{', '{');
      result = result.replace('}"', '}');
      result = JSON.parse(result);

     
      var resultDataModel = { 
        model:'', 
        model_year:'', 
      };

      try {
        // model 형식 & 연도가 ' '로 나뉘어있음 + 뒤에 공백 가능성 -> 공백 제거 후 model으로 data 재구성
        const modelString = result.data.model.trim();
        resultDataModel.model = modelString.split(' ')[0];   // model 형식
        resultDataModel.model_year = modelString.split(' ')[1];   // model 형식
      } catch (error) {
        console.log("OCR DATA error");
      }

      result.data.model = resultDataModel;
      result.data.model.model_slug = result.data.model.model

      if(result.data.owner_name) result.data.owner_name = result.data.owner_name.trim();

      if(result.data.reg_date) result.data.reg_date = result.data.reg_date.replace(Const.REG_EXP_BLANK, "");
      if(result.data.reg_date) result.data.reg_date = result.data.reg_date.replace(Const.REG_EXP_SPECIAL, "");

      if(result.data.car_vin) result.data.car_vin = result.data.car_vin.replace(Const.REG_EXP_BLANK, "");
      if(result.data.car_vin) result.data.car_vin = result.data.car_vin.replace(Const.REG_EXP_SPECIAL, "");

      if(result.data.car_reg_no) result.data.car_reg_no = result.data.car_reg_no.replace(Const.REG_EXP_BLANK, "");
      if(result.data.car_reg_no) result.data.car_reg_no = result.data.car_reg_no.replace(Const.REG_EXP_SPECIAL, "");


      // 자동차 등록증 이미지 저장 경로 vuex 에 저장 :: server에서 만든 get url parsing 해서 s3 path 추출
      const getUrl = new URL(result.url);
      this.$store.state.att.vehicle.num_reg.path = getUrl.pathname;
      this.$store.state.ocrData = result;

      // this.$router.push('/subscApply/vehicle');   // 자동차 등록증 촬영 다음페이지
    },

    // 자동차 등록증 OCR api 호출  20.03.16    sang
    // view -> SubscApplyVehicleRegView.vue로 이동 2020-11-30 jeon
    // callOCRCarRegApi() {
    //   // api paramater setting
    //   const plusId = this.$store.state.user.plus_id.toString();
    //   const handleKey = 'handleKey';             // 현재 실제로 사용하지는 않음

    //   if (this.$store.state.isApp) {
    //     /*global runOCRCarReg*/
    //     runOCRCarReg(plusId, handleKey, this.S3UploadURL);
    //   } else {
    //     this.$router.push('/subscApply/vehicle');   // 자동차 등록증 촬영 다음페이지
    //   }
    // },

    // 계기판, 자동차 정기 검사 결과표 촬영 api 호출  20.03.16    sang
    // paramater:: Number type, 1:계기판 2: 자동차 정기 검사 결과표
    callTakePictureAndUploadApi(type) {
      //const plusId = this.$store.state.user.plus_id.toString();
      const vtgId = this.$store.state.user.vtg_id.toString();

      console.log('appConnectMixin isApp : ' + this.$store.state.isApp);

      if (this.$store.state.isApp) {
        /*global runTakePictureAndUpload*/
        runTakePictureAndUpload(vtgId, type, this.S3UploadURL);
      } else if ( this.$store.state.isDev) {
        if (type == 1) {
          this.$store.state.att.vehicle.insp.path = this.webImagePath;
          this.$router.push(`/subscApply/req?step=7`);
        } else if (type == 2) {
          this.$store.state.att.vehicle.panel.path = this.webImagePath;
          this.$router.push(`/subscApply/vehiclePanel?step=6`);
        }
      }
      
      
    },

    // RunTakePicture callback 데이터 처리 method
    callbackRunTakePictureSubmit(value) {
      const result = JSON.parse(value);
      const getUrl = new URL(result.url);

      // 계기판 촬영 후 다음 화면(결제화면)
      if (result.type == '1') {
        this.$store.state.att.vehicle.insp.path = getUrl.pathname;
        this.$router.push('/subscApply/req?step=7');
      }
      // 자동차 정기검사 결과표 촬영 후 화면으로 routing (계기판 촬영 전 수기입력화면)
      else if (result.type == '2') {
        this.$store.state.att.vehicle.panel.path = getUrl.pathname;
        this.$router.push('/subscApply/vehiclePanel?step=6');
      }
    },
  }
}
